// Optimistic event-mark verify toggle. Mirrors useAccoladeVerify: optimistic
// set + revert-on-error, hitting the per-mark verify endpoint
// (POST /event-marks/athlete/{userId}/{id}/verify) which returns the updated
// row. Staff/partner only — the caller gates rendering on perms.canVerify.
import { useState } from 'react';
import axios from 'axios';

export default function useMarkVerify({ userId, apiUrl, getConfig, setMarks }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (m) => {
    const next = !m.verified;
    setBusyId(m.id);
    setMarks(list => list.map(x => (x.id === m.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/event-marks/athlete/${userId}/${m.id}/verify`, {}, getConfig());
      // The verify endpoint returns _row (no derived is_pr/is_sb); merge its
      // fields onto the existing row so the PR/SB badges survive the toggle.
      setMarks(list => list.map(x => (x.id === m.id ? { ...x, ...res.data } : x)));
    } catch {
      // revert
      setMarks(list => list.map(x => (x.id === m.id ? { ...x, verified: m.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
